import api from './api';

const procurementApproverMasterService = {
  // Get all procurement approvers
  getAllProcurementApprovers: async (params = {}) => {
    try {
      const queryParams = new URLSearchParams();
      if (params.page) queryParams.append('page', params.page);
      if (params.limit) queryParams.append('limit', params.limit);
      if (params.status) queryParams.append('status', params.status);
      if (params.approvalLevel) queryParams.append('approvalLevel', params.approvalLevel);
      if (params.search) queryParams.append('search', params.search);

      const queryString = queryParams.toString();
      const url = `/procurement-approver-master${queryString ? `?${queryString}` : ''}`;
      
      const response = await api.get(url);
      return response.data;
    } catch (error) {
      console.error('Error fetching procurement approvers:', error);
      throw error;
    }
  },

  // Get procurement approver by ID
  getProcurementApproverById: async (id) => {
    try {
      const response = await api.get(`/procurement-approver-master/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching procurement approver:', error);
      throw error;
    }
  },

  // Get next approver code
  getNextApproverCode: async () => {
    try {
      const response = await api.get('/procurement-approver-master/code/next');
      return response.data;
    } catch (error) {
      console.error('Error fetching next approver code:', error);
      throw error;
    }
  },

  // Create procurement approver
  createProcurementApprover: async (approverData) => {
    try {
      const response = await api.post('/procurement-approver-master', approverData);
      return response.data;
    } catch (error) {
      console.error('Error creating procurement approver:', error);
      throw error;
    }
  },

  // Update procurement approver
  updateProcurementApprover: async (id, approverData) => {
    try {
      const response = await api.put(`/procurement-approver-master/${id}`, approverData);
      return response.data;
    } catch (error) {
      console.error('Error updating procurement approver:', error);
      throw error;
    }
  },

  // Delete procurement approver
  deleteProcurementApprover: async (id) => {
    try {
      const response = await api.delete(`/procurement-approver-master/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting procurement approver:', error);
      throw error;
    }
  },

  // Get procurement approver statistics
  getProcurementApproverStats: async () => {
    try {
      const response = await api.get('/procurement-approver-master/stats');
      return response.data;
    } catch (error) {
      console.error('Error fetching procurement approver statistics:', error);
      throw error;
    }
  }
};

export default procurementApproverMasterService;

